/** Shared invoice line math for PDF normalization (matches order/invoice UI). */

export { toAmount as invoiceAmount, combinedAmount as invoiceCombined, formatMoney, vat18FromCombined } from '../../utils/formatMoney';

export function formatSkuDisplay(raw) {
    if (raw == null) return '';
    const s = String(raw);
    if (s.length > 20) return s;
    return s.replace(/(\d{3})(?=\d)/g, '$1.');
}
